/* eslint-disable */
import { userLogin, logout, getInfo } from 'api/user'
import { utilCookies } from '@/util/cookies'

const state = {
  token: utilCookies.getToken(), //getToken(),
  name: '10000',
  staffId: '',
  staffName: '',
  staffDepartment: '',
  contractCount: {},
  avatar: '',
  roles: [],
  company_info: {},
  subProjectInfo: {}
}

const mutations = {
  SET_TOKEN: (state, token) => {
    state.token = token
  },
  SET_NAME: (state, name) => {
    state.name = name
  },
  SET_STAFF_ID: (state, staffId) => {
    state.staffId = staffId
  },
  SET_STAFF_NAME: (state, staffName) => {
    state.staffName = staffName
  },
  SET_STAFF_DEPARTMENT: (state, staffDepartment) => {
    state.staffDepartment = staffDepartment
  },
  SET_CONTRACT_COUNT: (state, contractCount) => {
    state.contractCount = contractCount
  },
  SET_AVATAR: (state, avatar) => {
    state.avatar = avatar
  },
  SET_ROLES: (state, roles) => {
    state.roles = roles
  },
  COMPANY_INFO: (state, info) => {
    state.company_info = info
  },
  SUB_PROJECT_INFO: (state, info) => {
    state.subProjectInfo = info
  }
}

const actions = {
  setProjectInfo({ commit }, info) {
    commit('SUB_PROJECT_INFO', info)
  },
  setUserInfo({ commit }, { staff_id, name, department }) {
    commit('SET_STAFF_ID', staff_id)
    commit('SET_STAFF_NAME', name)
    commit('SET_STAFF_DEPARTMENT', department)
  },
  setContractCount({ commit }, contractCount) {
    commit('SET_CONTRACT_COUNT', contractCount)
  },
  // user login
  login({ commit }, loginInfo) {
    return new Promise((resolve, reject) => {
      userLogin(loginInfo)
        .then(response => {
          utilCookies.setToken(response.data.token)
          resolve()
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  // get user info
  getInfo({ commit, state }) {
    return new Promise((resolve, reject) => {
      getInfo(state.token)
        .then(response => {
          const { data } = response

          if (!data) {
            reject('Verification failed, please Login again.')
          }

          const { roles, name, avatar } = data

          // roles must be a non-empty array
          if (!roles || roles.length <= 0) {
            reject('getInfo: roles must be a non-null array!')
          }

          commit('SET_ROLES', roles)
          commit('SET_NAME', name)
          commit('SET_AVATAR', avatar)
          resolve(data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  // user logout
  logout({ commit, state }) {
    return new Promise((resolve, reject) => {
      logout(state.token)
        .then(() => {
          utilCookies.removeToken()
          // commit('SET_TOKEN', '')
          // commit('SET_ROLES', [])
          // resetRouter()
          resolve()
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  // remove token
  resetToken({ commit }) {
    return new Promise(resolve => {
      commit('SET_TOKEN', '')
      commit('SET_ROLES', [])
      utilCookies.removeToken()
      resolve()
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
